/* eslint-disable react/jsx-props-no-spreading */
import './Spinner.scss';

import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

const Spinner = ({ className, id, size, variant }) => {
  const classNames = useMemo(
    () =>
      ['spinner', `spinner--${variant}`, `spinner--${size}`, className]
        .filter((val) => val)
        .join(' '),
    [className, variant, size],
  );

  const conditionalProps = useMemo(
    () => ({
      ...(id ? { id } : {}),
    }),
    [id],
  );

  return (
    <span data-qa-id="spinner" className={classNames} {...conditionalProps} />
  );
};

Spinner.defaultProps = {
  className: '',
  id: null,
  size: 'small',
  variant: 'default',
};
Spinner.propTypes = {
  className: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOf(['small', 'large']),
  variant: PropTypes.oneOf(['default', 'primary', 'secondary']),
};
export default Spinner;
